var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-container pb-3"},[_c('TitleBlock',{staticClass:"mb-5"}),_c('InfoBlock',{attrs:{"event":_vm.event}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }